export type FeatureFlagType = 'toggle' | 'range-date';

export type FeatureFlagRangeDate = {
  to: string;
  from: string;
  url: string;
  printPixel: string;
};

export interface FeatureFlagToggleEnv {
  type?: 'toggle';
  development: boolean;
  preprod: boolean;
  production: boolean;
}

export interface FeatureFlagRangeDateEnv {
  type?: 'range-date';
  development: FeatureFlagRangeDate;
  preprod: FeatureFlagRangeDate;
  production: FeatureFlagRangeDate;
}

export enum FeatureFlag {
  SUPER_USER = 'superUser',
  FOLLOWING = 'following',
  STRIPE = 'stripe',
  BADGES = 'badges',
  CONVERSATION_PICTURE = 'conversationPicture',
}

export type FeatureFlagKeys = FeatureFlag;

export type FeatureFlagResult = {
  [key in FeatureFlagKeys]?: {
    title: string;
    description: string;
    app: FeatureFlagToggleEnv | FeatureFlagRangeDateEnv;
    web: FeatureFlagToggleEnv | FeatureFlagRangeDateEnv;
  };
};
